import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { delay } from "./Utils";

gsap.registerPlugin(ScrollTrigger, SplitText);

export class BlurScrollEffect {
  constructor(textElement) {
    // Check if the provided element is valid.
    if (!textElement || !(textElement instanceof HTMLElement)) {
      throw new Error("Invalid text element provided.");
    }

    // set el
    this.textElement = textElement;

    // Set up the effect for the provided text element.
    this.initializeEffect();
  }

  // Sets up the initial text effect on the provided element.
  initializeEffect() {
    // Callback to re-trigger animations on resize.
    const textResizeCallback = () => this.scroll();

    // Split text for animation and store the reference.
    this.splitter = new SplitText(this.textElement, {
      type: "words,chars",
    });

    gsap.set(this.textElement, { perspective: 400 });

    // Trigger the initial scroll effect.
    this.scroll();
  }

  // Animates text based on the scroll position.
  scroll() {
    const chars = this.splitter.chars;
    gsap.fromTo(
      chars,
      {
        filter: "blur(8px)",
        opacity: 0,
        scale: () => gsap.utils.random(0.25, 2),
        rotationY: () => gsap.utils.random(-45, 45),
        rotationX: () => gsap.utils.random(-45, 45),
        rotationZ: () => gsap.utils.random(-90, 90),
        transformOrigin: "0% 50% -50",
        willChange: "opacity, filter, transform",
      },
      {
        duration: 1,
        opacity: 1,
        scale: 1,
        rotationY: 0,
        rotationZ: 0,
        rotationX: 0,
        ease: "back.out", // Animation easing.
        filter: "blur(0px)",
        stagger: 0.01, // Delay between starting animations for each character.
        scrollTrigger: {
          trigger: this.textElement, // Element that triggers the animation.
          start: "top top+=95%", // Animation starts when element hits bottom of viewport.
          end: "bottom center+=20%", // Animation ends in the center of the viewport.
          toggleActions: "play none none none",
          scrub: false, // Animation progress tied to scroll position.
        },
      }
    );
  }
}
